// extracted by mini-css-extract-plugin
export default {"wrapper":"y0LT2N","patient-gpt-cta-border-hover-rotate":"wpu8xw","wrapper--animated":"eCK3Ye","patient-gpt-cta-border-rotate":"zn8bMP","link":"hVQyb9"};